import { CognitoUserPool } from "amazon-cognito-identity-js";
import { COGNITO_USER_POOL_ID, COGNITO_CLIENT_ID } from "@/lib/env";

const poolId   = COGNITO_USER_POOL_ID;
const clientId = COGNITO_CLIENT_ID;

export const isCognitoConfigured = Boolean(poolId && clientId);

/** Local demo: skip Cognito when backend is localhost gateway (development only). */
export function isLocalDevBypassEnabled() {
  if (process.env.NODE_ENV !== "development") return false;
  if (isCognitoConfigured) return false;
  if (process.env.REACT_APP_DEV_BYPASS_AUTH === "false") return false;
  const backend = (process.env.REACT_APP_BACKEND_URL || "").toLowerCase();
  return backend.includes("localhost") || backend.includes("127.0.0.1");
}

export const cognitoUserPool = isCognitoConfigured
  ? new CognitoUserPool({
      UserPoolId: poolId,
      ClientId: clientId,
    })
  : null;

const DEV_USER = { email: "dev@localhost", sub: "local-dev-bypass" };

export function getLocalDevUser() {
  return DEV_USER;
}
